import './style.sass';
import { Dropdown } from 'app/components/common/Dropdown';
import { SelectItem } from 'app/components/common/SelectItem';
import { CampaignStatus } from 'common/types/models/campaign';
import { CampaignStatusTitle } from 'app/utils/campaignStatusHelpers';
import { ValueModel } from '@zajno/common-mobx/viewModels';
import filterIcon from 'assets/img/icons/filter-flag.svg';
import { ReactSVG } from 'react-svg';
import { observer } from 'mobx-react-lite';
import { useBreakpointType } from 'app/services/breakpoints';
import { useState } from 'react';

type Props = {
    model: ValueModel<CampaignStatus[]>,
    onChange: (status: CampaignStatus) => void,
};

const CAMPAIGN_STATUSES = CampaignStatus.Helper.Values;

export const CampaignsFiltersDropdown = observer(({ model, onChange }: Props) => {
    const [isActiveDropdown, setIsActiveDropdown] = useState<boolean>(false);

    const { isMobile } = useBreakpointType();
    const isFilled = !!model.value.length;

    return (
        <Dropdown
            isActive={isActiveDropdown}
            setIsActive={setIsActiveDropdown}
            button={
                <div className={`campaign-filters-dropdown__btn ${isFilled ? 'filled' : ''}`}>
                    <ReactSVG
                        className="campaign-filters-dropdown__btn-icon"
                        src={filterIcon}
                    />

                    <span className={`p2-medium ${isFilled ? 'violet-text' : 'dark-violet'}`}>
                        Statuses
                    </span>
                </div>
            }
            className="campaign-filters-dropdown"
            type="white"
            title="Show statuses"
            hasArrow={false}
            directionX={isMobile ? 'left' : 'right'}
        >
            <div className="campaign-filters-dropdown__list">
                {CAMPAIGN_STATUSES.map((item, index) => (
                    <SelectItem
                        key={`${index}_select-item_${item}`}
                        isActive={model.value?.includes(item)}
                        onClickItem={() => onChange(item)}
                        text={CampaignStatusTitle[item]}
                        type='light'
                    />
                ))}
            </div>
        </Dropdown>
    );
});
